var SCM = SCM || {};
SCM.BookToc = SCM.BookToc || {};

(function (ns, $) {

    ns.init = function () {
        ns.registerHeadingsEvents();
        ns.checkAccess();
        if ($('#hfIsBookTocSlim').val()) {
            ns.addNotesTocLink();
            $('.js-tocLink.active').last().attr('aria-current', 'true'); // set the latest active heading to current for left rail
        }
    };

    ns.registerHeadingsEvents = function () {
        $(document).on('click', '.js-show-headings-button', onHeadingsClick);
        $(document).on('click', '.js-show-book-parts', onBookPartHeadingsClick);

        // for chapter left rail TOC
        if ($('#hfIsBookTocSlim').val()) {
            $(document).on('click', '.js-tocLink:not(.book-part-only)', onHeadingsClick);
        }
    };

    ns.checkAccess = function () {
        if ($('.chapter-user-restricted').length) {
            var $activeLink = $('.js-tocLink.active');
            if ($activeLink.length) {
                var $chapterLink = $activeLink.closest('.js-toc-chapter-link');
                // turn off the chapter subheading links and make them spans
                $chapterLink.find('.js-jumplink').addClass('hide').removeAttr('href');
                $chapterLink.find('.js-jumplink-span').removeClass('hide');
            }
        }
    };

    /**
    * manually add the Notes link in the Chapter TOC if end notes widget exists and has data
    */
    ns.addNotesTocLink = function () {
        var $endNotes = $('#endNotesTargetLocation').find('.widget-items');
        var $footNotes = $('#chapter-footnotes');
        var $chapterLink = $('.js-tocLink.active:last');
        // special case where you are on an end matter page that is not in left rail 
        // due to null title, but you still have to navigate to it with next/prev
        // no chapter will be active, so you don't want to hide the headings
        if ($chapterLink.length) {
            var $chapterSections = $chapterLink.closest('.js-toc-chapter-link');
            if ($chapterSections.length) {
                var $endNotesLink = $chapterSections.find('.js-toc-notes-link');
                var $footNotesLink = $chapterSections.find('.js-toc-footnotes-link');

                if ($endNotes.length && $endNotes.html().trim() != '' && $endNotesLink.length) {
                    $endNotesLink.removeClass('hide');
                    SCM.JumpLinks.registerNotesTocLink('#endNotesTargetLocation', 'js-notes-link-end-notes');
                }

                if ($footNotes.length && $footNotesLink.length) {
                    $footNotesLink.removeClass('hide');
                    SCM.JumpLinks.registerNotesTocLink('#chapter-footnotes', 'js-notes-link-chapter-footnotes');
                }

                if (shouldHideExpandButton($chapterSections, $endNotes, $footNotes)) {
                    $chapterSections.find('.js-show-headings-button').addClass('hide');
                }
            }
            else {
                $('.js-show-headings-button').addClass('hide');
            }
        }
    };

    ns.onHeadingsClick = onHeadingsClick;
    ns.onBookPartHeadingsClick = onBookPartHeadingsClick;

    function shouldHideExpandButton($chapterSections, $endNotes, $footNotes) {
        return !$endNotes.length &&
            !$footNotes.length &&
            !$chapterSections.find('.js-toc-chapter-link:not(.hide)').length;
    }

    function onHeadingsClick(e) {
        var $icon = $(e.target).find('.js-show-headings-icon');
        if (!$icon.length) {
            $icon = $(e.target).closest('.js-nav-tree-item').find('.js-show-headings-icon').first();
        }
        if (!$icon.length) {
            console.error('.js-show-headings-icon not found');
            return;
        }

        var sectionId = $icon.data('sectionid');
        if (!sectionId) {
            console.error('sectionid not found');
            return;
        }

        var targetUrl = $icon.data('targeturl');
        if (!targetUrl) {
            console.error('targeturl not found');
            return;
        }
        var $placeholder = $('.js-headings-placeholder[data-sectionid=' + sectionId + ']');
        if (!$placeholder.length) {
            console.error('.js-headings-placeholder not found');
            return;
        }

        // needed so that split-view and standard view arrow icons stay in sync
        var $icons = $('.js-show-headings-icon[data-sectionid=' + sectionId + ']');
        var $parentAnchors = $('.tocLink[aria-owns$=' + sectionId + ']');
        var $screenReaderPrompts = $parentAnchors.siblings('.js-nav-tree-toggle').find('.screenreader-text');

        // If we expanded to show the headings
        if ($icon.hasClass('icon-general-arrow-filled-right')) {
            // If we haven't fetched the headings yet
            if (!$placeholder.children().length) {
                var url = window.location.origin + '/Book/ChapterHeadings';
                $.ajax({
                    url: url,
                    data: {
                        chapterId: sectionId,
                        targetUrl: targetUrl,
                        BypassOutputCache: IsBypassOutputCacheEnabled()
                    }
                }).done(function (ajaxResponse) {
                    if (!ajaxResponse || !ajaxResponse.length) {
                        return;
                    }
                    $placeholder.append(ajaxResponse);
                }).fail(function (xmlHttpRequest, textStatus) {
                    if (window.console && window.console.error) {
                        console.error('error: ' + xmlHttpRequest.responseText);
                        console.error('status: ' + textStatus);
                        $icons.removeClass('icon-general-arrow-filled-down');
                        $icons.addClass('icon-general-arrow-filled-right');
                        $icons.addClass('disabled');
                        return;
                    }
                });
            }

            $icons.removeClass('icon-general-arrow-filled-right');
            $icons.addClass('icon-general-arrow-filled-down');
            $parentAnchors.attr('aria-expanded', 'true');
            $screenReaderPrompts.text('Collapse');

        } else if ($icon.hasClass('icon-general-arrow-filled-down')) {

            $icons.removeClass('icon-general-arrow-filled-down');
            $icons.addClass('icon-general-arrow-filled-right');
            $parentAnchors.attr('aria-expanded', 'false');
            $screenReaderPrompts.text('Expand');
        }

        $placeholder.toggleClass('hide');
    }

    function onBookPartHeadingsClick(e) {
        var $button = $(e.target).closest('.js-show-book-parts');

        var $icon = $button.find('.js-show-book-parts-icon');
        if (!$icon.length) {
            console.error('.show-book-parts-icon not found');
            return;
        }

        var sectionId = $icon.data('sectionid');
        if (!sectionId) {
            console.error('sectionid not found');
            return;
        }

        var $placeholder = $('.collections-child-list[data-sectionid=' + sectionId + ']');

        var $screenReaderPrompts = $icon.find('.screenreader-text');

        if ($icon.hasClass('icon-general-arrow-filled-right')) {
            $icon.removeClass('icon-general-arrow-filled-right');
            $icon.addClass('icon-general-arrow-filled-down');
            $button.attr('aria-expanded', 'true');
            $screenReaderPrompts.text('Collapse');
        } else if ($icon.hasClass('icon-general-arrow-filled-down')) {
            $icon.removeClass('icon-general-arrow-filled-down');
            $icon.addClass('icon-general-arrow-filled-right');
            $button.attr('aria-expanded', 'false');
            $screenReaderPrompts.text('Expand');
        }

        $placeholder.toggleClass('hide');
    }

    function IsBypassOutputCacheEnabled() /* -> boolean */ {
        return window.location.search.toLowerCase().indexOf('bypassoutputcache=true') > -1;
    }

})(SCM.BookToc.Headings = SCM.BookToc.Headings || {}, jQuery);